// libs
import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
// components
import { Box, Typography } from '@lyearn/ui';

const scoreTabsClasses =
  'h-42 w-42 xs:h-44 xs:w-44 bg-bg-secondary border border-solid border-divider rounded-full flex items-center justify-center';
const selectedClasses =
  'h-42 w-42 xs:h-44 xs:w-44 bg-text-primary rounded-full flex items-center justify-center';

function Score({
  questionId,
  isSelected,
  classname,
  value,
  isDisabled,
  onAction,
  score,
}: {
  questionId: string;
  classname?: string;
  isSelected: boolean;
  value: string | number;
  isDisabled: boolean;
  onAction?: (id: string, feebackType: 'score' | 'input', score: number) => void;
  score: number;
}) {
  const onScoreClick = useCallback(() => {
    onAction && onAction(questionId, 'score', score);
  }, [onAction, questionId, score]);

  return (
    <Box
      className={cn(
        classname,
        isSelected ? selectedClasses : scoreTabsClasses,
        isDisabled ? 'bg-bg-secondary' : onAction ? 'cursor-pointer' : '',
      )}
      onClick={isDisabled ? undefined : onScoreClick}>
      <Typography
        color={
          isSelected
            ? 'text-text-white'
            : isDisabled
            ? 'text-text-placeholder'
            : 'text-text-primary'
        }
        variant="body-short-02">
        {value}
      </Typography>
    </Box>
  );
}

export default React.memo(Score);
